import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { sendError } from "../errors";
import companyApi from "../api/company";

export const fetchCompanyUsers = createAsyncThunk(
  "tasks/fetchCompanyUsersStatus",
  async () => {
    return await companyApi.fetchUsers();
  }
);

export const companySlice = createSlice({
  name: "company",
  initialState: {
    company: null,
    users: [],
    usersLoaded: false,
    usersLoading: false,
    usersLoadingError: null,
  },
  reducers: {
    setCompany: (state, { payload }) => {
      state.company = payload;
    },
  },
  extraReducers: (builder, x) => {
    builder.addCase(fetchCompanyUsers.pending, (state) => {
      state.usersLoading = true;
    });
    builder.addCase(fetchCompanyUsers.fulfilled, (state, action) => {
      state.users = action.payload;
      state.usersLoading = false;
      state.usersLoaded = true;
    });
    builder.addCase(fetchCompanyUsers.rejected, (state, action) => {
      sendError(action.error, { company: state.company });
      state.usersLoadingError = action.error;
      state.usersLoading = false;
      state.usersLoaded = true;
    });
  },
});

// SELECTORS

export const selectSeeingCompanyPages = (state) => !!state.company?.company;
export const selectCompany = (state) => state.company?.company;
export const selectCompanyUsers = (state) => state.company.users;
export const selectAreCompanyUsersLoaded = (state) => state.company.usersLoaded;
export const selectAreCompanyUsersLoading = (state) =>
  state.company?.usersLoading;
export const selectCompanyUsersLoadingError = (state) =>
  state.company?.usersLoadingError;
export function selectCompanyUserById(userId) {
  return (state) => state.company.users.find((u) => u.id == userId);
}

// ACTIONS

export const { setCompany } = companySlice.actions;

export default companySlice.reducer;
